<template>
  <select
    v-model="selectedChild"
    class="browser-default"
    v-if="childObjects.length > 0"
  >
    <option :value="null"></option>
    <option v-bind:class="{ 'alarm': child.monitorStatusId===3, 'warning': child.monitorStatusId===2  }" v-for="(child, index) in childObjects" :value="child" :key="index">{{ child.Name }}</option>
  </select>
</template>

<script>
export default {
  name: 'ChildSelector',
  components: {},
  props: {
    childObjects: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selectedChild: null
    }
  },
  computed: {},
  watch: {
    childObjects () {
      if (this.childObjects.length === 1) {
        this.selectedChild = this.childObjects[0]
      }
    },
    selectedChild () {
      this.setChild()
    }
  },
  methods: {
    setChild () {
      this.$emit('setChild', this.selectedChild)
    }
  }
}
</script>

<style scoped>
.alarm {
  color: red
}

.warning {
  color: orange
}
</style>



// WEBPACK FOOTER //
// src/components/switch/ChildSelector.vue